module.exports = __webpack_public_path__ + "img/IIAS.eb9eeb32.png";